import { put, call, select, all } from 'redux-saga/effects'
import { pathOr } from 'ramda'

import { routeIdSelector, shownRoutesSelector, fromUaRouteSelector } from 'reduxModules/selectors/RouteSelectors'
import { fromToCitiesSelector } from 'reduxModules/selectors/CitySelectors'
import { getElIdFromPath } from 'services/helpers'
import { snackbarActions } from 'reduxModules/actions/SnackbarActions'

import { rsf } from '../../firebase'

export function* getPricesSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    const routeId = yield select(routeIdSelector)
    const fromUaRoute = yield select(fromUaRouteSelector)
    const splitedRouteId = routeId.split('_')
    const res = yield call(rsf.firestore.getCollection, `routes/${routeId}/prices`)

    if (!res.empty) {
      const prices = []

      yield res.forEach(price => prices.push({ id: price.id.trim(), returned: false, ...price.data() }))

      if (fromUaRoute) {
        const returnRouteId = `${splitedRouteId[1]}_${splitedRouteId[0]}`

        const res = yield call(rsf.firestore.getCollection, `routes/${returnRouteId}/prices`)

        if (!res.empty) {
          yield res.forEach(price => prices.push({ id: price.id.trim(), returned: true, ...price.data() }))
        } else {
          yield put(snackbarActions.showSnackbar({
            type: 'error',
            message: 'Сталась помилка під час завантаження зворотніх цін!'
          }))
        }
      }

      yield put(responseSuccess(prices))
    } else {
      yield put(snackbarActions.showSnackbar({
        type: 'error',
        message: 'Сталась помилка під час завантаження цін!'
      }))
    }
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження цін!'
    }))
  }
}

export function* setPriceSaga(action) {
  const { responseSuccess, responseFailure, data: { id, value, returned } } = action

  try {
    const routeId = yield select(routeIdSelector)
    const splitedRouteId = routeId.split('_')
    const returnRouteId = `${splitedRouteId[1]}_${splitedRouteId[0]}`
    const route = returned ? returnRouteId : routeId

    yield call(
      rsf.firestore.setDocument,
      `routes/${route}/prices/${id}`,
      { price: value },
      { merge: true }
    )

    yield put(responseSuccess())

    yield put(snackbarActions.showSnackbar({
      type: 'success',
      message: 'Ціна успішно оновленна!'
    }))
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час оновлення ціни!'
    }))
  }
}

export function* getCitiesRoutePriceSaga(action) {
  const { responseSuccess, responseFailure } = action

  try {
    const routeIds = yield select(shownRoutesSelector)
    const fromToCities = yield select(fromToCitiesSelector)

    const res = yield all(
      routeIds.map(routeId => call(rsf.firestore.getDocument, `routes/${routeId}/prices/${fromToCities}`))
    )

    const citiesRoutePrice = res.reduce((acc, item) => {
      const routeId = getElIdFromPath(item.ref.path, 2)

      acc[routeId] = +pathOr(0, ["price"], item.data())

      return acc
    }, {})

    yield put(responseSuccess(citiesRoutePrice))
  } catch (err) {
    console.log(err)
    yield put(responseFailure())
    yield put(snackbarActions.showSnackbar({
      type: 'error',
      message: 'Сталась помилка під час завантаження цін для маршрутів!'
    }))
  }
}



// WEBPACK FOOTER //
// ./src/reduxModules/sagas/PriceSagas.js